import React, { useState, useEffect, Fragment, useRef } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { Typography, Box, Card, makeStyles, Container, CardContent, Divider, MenuItem, Grid, InputLabel, TextField, CardHeader, Button, Chip, Checkbox } from '@material-ui/core';
import Page from 'src/components/Page';
import services from '../Services';
import { trackPromise } from 'react-promise-tracker';
import { useAlert } from "react-alert";
import authService from '../../../utils/permissionAuth';
import tokenService from '../../../utils/tokenDecoder';
import { useNavigate } from 'react-router-dom';
import { Formik } from 'formik';
import * as Yup from "yup";
import MaterialTable from "material-table";
import VisibilityIcon from '@material-ui/icons/Visibility';
import CancelIcon from '@material-ui/icons/Cancel';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { LoadingComponent } from '../../../utils/newLoader';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  textcolor: {
    color: 'blue'
  },
  fontSizer: {
    fontWeight: "bold",
    fontSize: "30px"
  },
  colorApprove: {
    backgroundColor: "green",
  },
  multilineColor: {
    color: 'red'
  }
}));

const screenCode = 'FESTIVALADVANCEPAYMENTAPPROVAL';

const statusMap = {
  1: 'Pending',
  2: 'Approved',
  3: 'Rejected'
};

export default function FestivalAdvancePaymentApprovalListing() {
  const classes = useStyles();
  const componentRef = useRef();
  const [title] = useState("Festival Advance Payment Approval");
  const [groups, setGroups] = useState();
  const [factories, setFactories] = useState();
  const alert = useAlert();
  const [routes, setRoutes] = useState();
  const navigate = useNavigate();
  const [approveList, setApproveList] = useState({
    groupID: '0',
    factoryID: '0',
    routeID: '0',
    regNumber: '',
    statusID: '0'
  });

  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false,
    isAdvancePaymentChangeEnabled: false,
    isAdvanceRateChangeEnabled: false,
    isMonthlyBalanceChangeEnabled: false,
    isSendToOverAdvanceEnabled: false,
    isIssuePermissionEnabled: false,
    isIssuingDateEnabled: false,
    isViewTotalAmount: false,
    isViewAvailableAmount: false
  });

  const [festivalAdvancePaymentData, setFestivalAdvancePaymentData] = useState([]);
  const [hiddenTable, setHiddenTable] = useState(true);
  const [selectedRows, setSelectedRows] = useState([]);

  const getStatusName = (statusID) => {
    return statusMap[statusID] || 'Unknown';
  };

  useEffect(() => {
    trackPromise(getGroupsForDropdown(), getPermission());
  }, []);

  useEffect(() => {
    if (approveList.groupID !== '0') {
      setFestivalAdvancePaymentData([]);
      trackPromise(getfactoriesForDropDown());
    }
  }, [approveList.groupID]);

  useEffect(() => {
    if (approveList.factoryID !== '0') {
      setApproveList({
        ...approveList,
        routeID: '0',
        });
      setFestivalAdvancePaymentData([]);
      trackPromise(getRoutesByFactoryID());
    }
  }, [approveList.factoryID]);

  useEffect(() => {
      setFestivalAdvancePaymentData([]);
  }, [approveList.routeID]);

  async function getPermission() {
    try {
      const permissions = await authService.getPermissionsByScreen(screenCode);
      const isAuthorized = permissions.find(p => p.permissionCode == 'VIEWFESTIVALADVANCEPAYMENTAPPROVAL');

      if (!isAuthorized) {
        navigate('/404');
        return;
      }

      setPermissions({
        isGroupFilterEnabled: permissions.some(p => p.permissionCode == 'GROUPDROPDOWN'),
        isFactoryFilterEnabled: permissions.some(p => p.permissionCode == 'FACTORYDROPDOWN'),
        isAdvancePaymentChangeEnabled: permissions.some(p => p.permissionCode === 'ADVANCEPAYMENTPERMISSION'),
        isAdvanceRateChangeEnabled: permissions.some(p => p.permissionCode == "ADVANCERATECHANGEPERMISSION"),
        isMonthlyBalanceChangeEnabled: permissions.some(p => p.permissionCode == "MONTHLYBALANCECHANGINGPERMISSION"),
        isSendToOverAdvanceEnabled: permissions.some(p => p.permissionCode == "SENDTOOVERADVANCEPERMISSION"),
        isIssuePermissionEnabled: permissions.some(p => p.permissionCode == "ADVANCEISSUEPERMISSION"),
        isIssuingDateEnabled: permissions.some(p => p.permissionCode == "ISSUINGDATECHANGEPERMISSION"),
        isViewTotalAmount: permissions.some(p => p.permissionCode == "VIEWTOTALAMOUNT"),
        isViewAvailableAmount: permissions.some(p => p.permissionCode == "VIEWAVAILABLEAMOUNT")
      });

      setApproveList(prev => ({
        ...prev,
        groupID: parseInt(tokenService.getGroupIDFromToken()) || '0',
        factoryID: parseInt(tokenService.getFactoryIDFromToken()) || '0',
      }));
    } catch (error) {
      alert.error("Failed to load permissions");
    }
  }

  async function getfactoriesForDropDown() {
    try {
      const factory = await services.getfactoriesForDropDown(approveList.groupID);
      setFactories(factory);
    } catch (error) {
      alert.error("Failed to load factories");
    }
  }

  async function getGroupsForDropdown() {
    try {
      const groups = await services.getGroupsForDropdown();
      setGroups(groups);
    } catch (error) {
      alert.error("Failed to load groups");
    }
  }

  async function getRoutesByFactoryID() {
    try {
      const route = await services.getRouteForDropdown(approveList.factoryID);
      setRoutes(route);
    } catch (error) {
      alert.error("Failed to load routes");
    }
  }

  function generateDropDownMenu(data) {
    if (!data) return [<MenuItem key="0" value="0">--Select--</MenuItem>];

    return Object.entries(data).map(([key, value]) => (
      <MenuItem key={key} value={key}>{value}</MenuItem>
    ));
  }

  function handleChange(e) {
    const { name, value } = e.target;
    setApproveList(prev => ({
      ...prev,
      [name]: value
    }));
    if (name === 'groupID') {
      setApproveList({
        ...approveList,
        [name]: value,
        factoryID: '0',
        });
      }
  }

  async function GetDetails() {
    if (approveList.groupID === '0' || approveList.factoryID === '0' || approveList.routeID === '0' ||
      approveList.groupID === '' || approveList.factoryID === '' || approveList.routeID === '' ||
      approveList.groupID === null || approveList.factoryID === null || approveList.routeID === null ||
      approveList.groupID === 0 || approveList.factoryID === 0 || approveList.routeID === 0
    ) {
      return;
    } else {
      const details = await services.getFestivalAdvancePaymentRequests(
        approveList.groupID,
        approveList.factoryID,
        approveList.routeID,
        approveList.regNumber ? approveList.regNumber : 0,
        approveList.statusID
      );
      if (details.statusCode === "Success" && details.data) {
        setFestivalAdvancePaymentData(details.data);
        setHiddenTable(false);
        if (details.data.length === 0) {
          alert.error("No records to display");
          setHiddenTable(true);
        }
      } else {
        alert.error(details.message || "Error loading data");
      }
    }
  }

  const handleClickEdit = (festivalAdvancePaymentRequestID) => {
    const encrypted = btoa(festivalAdvancePaymentRequestID.toString());
    navigate(`/app/festivalAdvancePaymentApproval/view/${encrypted}`);
  };

  const handleRowCheckboxClick = (rowData) => {
    debugger;
    const rowId = rowData.festivalAdvancePaymentRequestID;

    setSelectedRows(prevSelected => {
      if (prevSelected.includes(rowId)) {
        return prevSelected.filter(id => id !== rowId);
      } else {
        return [...prevSelected, rowId];
      }
    });
  };
  const handleHeaderCheckboxClick = (event) => {
    if (event.target.checked) {
      const selectableRowIds = festivalAdvancePaymentData
        .filter(row => row.pending !== 0)
        .map(row => row.festivalAdvancePaymentRequestID);
      setSelectedRows(selectableRowIds);
    } else {
      setSelectedRows([]);
    }
  };
  const isAllSelectableRowsSelected = () => {
    const selectableRows = festivalAdvancePaymentData.filter(row => row.pending !== 0);
    return selectableRows.length > 0 &&
      selectedRows.length === selectableRows.length;
  };

  const isSomeSelectableRowsSelected = () => {
    const selectableRows = festivalAdvancePaymentData.filter(row => row.pending !== 0);
    return selectedRows.length > 0 &&
      selectedRows.length < selectableRows.length;
  };


  const handleApproveSelected = async () => {
    debugger;
    if (selectedRows.length === 0) {
      alert.error("Please select at least one record");
      return;
    }
    const response = await services.approveFestivalAdvancePayments(selectedRows);
    if (response.statusCode === "Success") {
      alert.success("Approval process completed successfully");
      trackPromise(GetDetails());
      setSelectedRows([]);
    } else {
      alert.error(response.message || "Approval process failed");
    }

  };

  const handleRejectSelected = async () => {
    debugger;
    if (selectedRows.length === 0) {
      alert.error("Please select at least one record");
      return;
    }

    try {
      const response = await services.rejectFestivalAdvancePayments(selectedRows);
      if (response.statusCode === "Success") {
        alert.success("Rejection process completed successfully");
        trackPromise(GetDetails());
        setSelectedRows([]);
      } else {
        alert.error(response.message || "Rejection process failed");
      }
    } catch (error) {
      console.error("Rejection error:", error);
      alert.error("An error occurred during rejection");
    }
  };
  return (
    <Fragment>
      <LoadingComponent />
      <Page className={classes.root} title="Festival Advance Payment Approval">
        <Container maxWidth={false}>
          <Formik
            initialValues={{
              groupID: approveList.groupID,
              factoryID: approveList.factoryID,
              routeID: approveList.routeID
            }}
            validationSchema={Yup.object().shape({
              groupID: Yup.string().required('Group is required').notOneOf(['0', null, 0], 'Group is required'),
                factoryID: Yup.string().required('Factory is required').notOneOf(['0', null, 0], 'Factory is required'),
                routeID: Yup.string().required('Route is required').notOneOf(['0', null, 0], 'Route is required'),
              })}
            enableReinitialize
          >
            {({ errors, handleBlur, handleSubmit, touched }) => (
              <form onSubmit={handleSubmit}>
                <Box mt={0}>
                  <Card>
                    <CardHeader title={title} />
                    <PerfectScrollbar>
                      <Divider />
                      <CardContent>
                        <Grid container spacing={3}>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="groupID">Group *</InputLabel>
                            <TextField
                              select
                              fullWidth
                              name="groupID"
                              onChange={handleChange}
                              value={approveList.groupID}
                              variant="outlined"
                              size="small"
                              error={Boolean(touched.groupID && errors.groupID)}
                              helperText={touched.groupID && errors.groupID}
                              InputProps={{
                                readOnly: !permissionList.isGroupFilterEnabled,
                              }}
                            >
                              <MenuItem value="0">--Select Group--</MenuItem>
                              {generateDropDownMenu(groups)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="factoryID">Factory *</InputLabel>
                            <TextField
                              select
                              fullWidth
                              name="factoryID"
                              onChange={handleChange}
                              value={approveList.factoryID}
                              variant="outlined"
                              size="small"
                              error={Boolean(touched.factoryID && errors.factoryID)}
                              helperText={touched.factoryID && errors.factoryID}
                              InputProps={{
                                readOnly: !permissionList.isFactoryFilterEnabled,
                              }}
                            >
                              <MenuItem value="0">--Select Factory--</MenuItem>
                              {generateDropDownMenu(factories)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="routeID">Route *</InputLabel>
                            <TextField
                              select
                              fullWidth
                              name="routeID"
                              size='small'
                              error={Boolean(touched.routeID && errors.routeID)}
                              helperText={touched.routeID && errors.routeID}
                              onChange={handleChange}
                              value={approveList.routeID}
                              variant="outlined"
                            >
                              <MenuItem value="0">--Select Route--</MenuItem>
                              {generateDropDownMenu(routes)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="statusID">Status </InputLabel>
                            <TextField
                              select
                              fullWidth
                              name="statusID"
                              size='small'
                              onChange={handleChange}
                              value={approveList.statusID}
                              variant="outlined"
                            >
                              <MenuItem value="0">--Select Status--</MenuItem>
                              <MenuItem value="1">Pending</MenuItem>
                              <MenuItem value="2">Approved</MenuItem>
                              <MenuItem value="3">Rejected</MenuItem>
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="regNumber">Customer Registration Number</InputLabel>
                            <TextField
                              fullWidth
                              name="regNumber"
                              onChange={handleChange}
                              value={approveList.regNumber}
                              variant="outlined"
                              size="small"
                              error={Boolean(touched.regNumber && errors.regNumber)}
                              helperText={touched.regNumber && errors.regNumber}
                              onBlur={handleBlur}
                            />
                          </Grid>
                        </Grid>
                        <Box display="flex" justifyContent="flex-end" p={2}>
                          <Button
                            color="primary"
                            type="submit"
                            variant="contained"
                            onClick={() => trackPromise(GetDetails())}
                          >
                            Search
                          </Button>
                        </Box>
                      </CardContent>

                      <Box minWidth={1050}>
                        {festivalAdvancePaymentData.length > 0 ? (
                          <div>
                            <MaterialTable
                              title="Festival Advance Payment Approvals"
                              columns={[
                                {
                                  title: (
                                    <Checkbox
                                      color="primary"
                                      checked={isAllSelectableRowsSelected()}
                                      indeterminate={isSomeSelectableRowsSelected()}
                                      onChange={handleHeaderCheckboxClick}
                                      disabled={festivalAdvancePaymentData.filter(row => row.statusID == 1)}
                                    />
                                  ),
                                  render: rowData => (
                                    <Checkbox
                                      color="primary"
                                      checked={selectedRows.includes(rowData.festivalAdvancePaymentRequestID)}
                                      onChange={() => handleRowCheckboxClick(rowData)}
                                      disabled={rowData.statusID == 3 || rowData.statusID == 2}
                                    />
                                  ),
                                },
                                {
                                  title: 'Registration Number',
                                  field: 'registrationNumber',
                                  cellStyle: { fontWeight: 500 }
                                },
                                {
                                  title: 'Customer Name',
                                  field: 'customerName',
                                  cellStyle: { fontWeight: 500 }
                                },
                                {
                                  title: 'Requested Amount',
                                  field: 'requestedAmount',
                                  render: rowData => (
                                    <span>
                                      {Number(rowData.requestedAmount).toLocaleString(undefined, {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                      })}
                                    </span>
                                  ),
                                  headerStyle: { textAlign: 'right', paddingRight: '6rem' },
                                  cellStyle: { textAlign: 'right', paddingRight: '8rem' }
                                },
                                {
                                  title: 'Status',
                                  field: 'statusID',
                                  render: rowData => (
                                    <Typography
                                      variant="body2"
                                      style={{
                                        color:
                                          rowData.statusID === 2 ? 'green' :
                                            rowData.statusID === 3 ? 'red' :
                                              '#f2c82e'
                                      }}
                                    >
                                      {getStatusName(rowData.statusID)}
                                    </Typography>
                                  )
                                },
                                {
                                  title: 'Actions',
                                  field: 'actions',
                                  render: rowData => (
                                    <Button
                                      startIcon={<VisibilityIcon fontSize="small" />}
                                      onClick={() => handleClickEdit(rowData.festivalAdvancePaymentRequestID, rowData.registrationNumber)}
                                    >
                                    </Button>
                                  ),
                                  sorting: false,
                                  width: 120
                                }
                              ]}
                              data={festivalAdvancePaymentData}
                              options={{
                                exportButton: false,
                                showTitle: false,
                                headerStyle: {
                                  backgroundColor: '#f5f5f5',
                                  fontWeight: 'bold',
                                  padding: '12px 16px'
                                },
                                cellStyle: { padding: '12px 16px' },
                                rowStyle: rowData => ({
                                  backgroundColor: selectedRows.includes(rowData.festivalAdvancePaymentRequestID)
                                    ? 'rgba(0, 0, 255, 0.08)'
                                    : '#fff'
                                }),
                                pageSize: 10,
                                pageSizeOptions: [10, 20, 50],
                                padding: 'dense',
                                actionsColumnIndex: -1,
                                selection: false,
                                showSelectAllCheckbox: false,
                                emptyRowsWhenPaging: false
                              }}
                              localization={{
                                toolbar: { searchPlaceholder: 'Search...' },
                                pagination: {
                                  labelDisplayedRows: '{from}-{to} of {count}',
                                  labelRowsSelect: 'rows'
                                }
                              }}
                            />

                            <Box mt={2} display="flex" justifyContent="flex-end" gap={2}>
                              <Button
                                variant="contained"
                                color="primary"
                                startIcon={<CheckCircleIcon />}
                                onClick={handleApproveSelected}
                                disabled={selectedRows.length === 0}
                                style={{
                                  minWidth: 180, marginRight: 10, marginBottom: 10
                                }}
                              >
                                Approve Selected ({selectedRows.length})
                              </Button>
                              <Button
                                variant="contained"
                                color="secondary"
                                startIcon={<CancelIcon />}
                                onClick={handleRejectSelected}
                                disabled={selectedRows.length === 0}
                                style={{ minWidth: 180, marginRight: 10, marginBottom: 10 }}
                              >
                                Reject Selected ({selectedRows.length})
                              </Button>
                            </Box>
                          </div>
                        ) : (
                          <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            height="200px"
                          >

                          </Box>
                        )}
                      </Box>
                    </PerfectScrollbar>
                  </Card>
                </Box>
              </form>
            )}
          </Formik>
        </Container>
      </Page>
    </Fragment>
  );
}